/**
 * Leituras de hodômetro medidas na abertura/fechamento manual da viagem (resposta de
 * gethodometrokmcarro). A tela grava a leitura da fonte preferida (com fallback na outra)
 * e manda as duas medições em `hodometros_medidos`; o backend escolhe o km final pela
 * regra única de api/utils/preferenciaHodometro.js.
 */
export function medeHodometros(hodometro, preferirVirtual) {
    const escolhe = (can, dtCan, virtual, dtVirtual) => {
        const usaVirtual = preferirVirtual ? virtual > 0 || !(can > 0) : !(can > 0);
        return usaVirtual ? { valor: virtual, dt: dtVirtual } : { valor: can, dt: dtCan };
    };
    const inicial = escolhe(hodometro.hodometro_can_inicial, hodometro.dt_hodometro_can_inicial,
        hodometro.hodometro_virtual_inicial, hodometro.dt_hodometro_virtual_inicial);
    const final = escolhe(hodometro.hodometro_can_final, hodometro.dt_hodometro_can_final,
        hodometro.hodometro_virtual_final, hodometro.dt_hodometro_virtual_final);
    return {
        hodometro_inicial: inicial.valor,
        dt_hodometro_inicial: inicial.dt,
        hodometro_final: final.valor,
        dt_hodometro_final: final.dt,
        km_aferido: final.valor - inicial.valor,
        hodometros_medidos: {
            hodometro_can_inicial: hodometro.hodometro_can_inicial,
            hodometro_can_final: hodometro.hodometro_can_final,
            hodometro_virtual_inicial: hodometro.hodometro_virtual_inicial,
            hodometro_virtual_final: hodometro.hodometro_virtual_final,
        },
    };
}
